export default __webpack_public_path__ + "static/media/H1008.2.2ca23cf1.mp3";